import { FormInput, FormInputFilter, SelectInput } from "@policoders/ds";

import {
  ITechnicalSheetItemFormProps,
  useTechnicalSheetItemForm,
} from "./technical-sheet-item.form.hook";

export const TechnicalSheetItemForm = ({ data, action }: ITechnicalSheetItemFormProps) => {
  const { state, products, getProductValue, measureUnitTypes, handleChange } =
    useTechnicalSheetItemForm({ data, action });

  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-lg-5">
          <FormInputFilter
            label="Produto"
            field="productId"
            placeholder="Digite o código do produto"
            value={getProductValue()}
            disabled={action === "edit"}
            options={products}
            onChange={handleChange}
          />
        </div>
        <div className="col-xs-12 col-lg-3">
          <FormInput
            type="text"
            label="Grupo"
            field="groupItem"
            value={state.groupItem}
            onChange={handleChange}
          />
        </div>
        <div className="col-xs-12 col">
          <FormInput
            type="number"
            label="Qtd. na receita"
            field="recipeQuantity"
            value={state.recipeQuantity}
            onChange={handleChange}
          />
        </div>
        <div className="col-xs-12 col">
          <SelectInput
            label="Unid. medida"
            field="measureUnit"
            value={state.measureUnit}
            options={measureUnitTypes()}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TechnicalSheetItemForm;
